import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useMemo, useRef, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import * as Yup from 'yup';
import { useToast } from "../../../Hooks/ToasContext";
import {  CustomerType, ICreateCustomerPayload, ICustomerEntity, IUpdateCustomerPayload } from "../../../Services/api/customers/customers.interface";
import { CreateCustomersUseCase } from "../../../Usecase/Customers/create-customers-usecase";
import { ShowCustomersUseCase } from "../../../Usecase/Customers/show-customers-usecase";
import { UpdateCustomersUseCase } from "../../../Usecase/Customers/update-customers-usecase";
import { v4 as uuid } from 'uuid'
import { removeNonNumeric } from "../../../utils/removeNonNumeric";
import { maskPhone } from "../../../utils/maskPhone";
import { IAddressEntity, ICreateAddressPayload } from "../../../Services/api/addresses/addresses.interface";
import { CreateAddressesUseCase } from "../../../Usecase/Addresses/create-addresses-usecase";
import { UpdateAddressesUseCase } from "../../../Usecase/Addresses/update-addresses-usecase";
import { DestroyAddressesUseCase } from "../../../Usecase/Addresses/destroy-addresses-usecase";
import { FindKeyWithPrefix } from "../../../utils/findKeyWithPrefix";
import { ICreateCustomerPaymentPreferencePayload, ICustomerPaymentPreferenceEntity, IDestroyCustomerPaymentPreferencePayload, IUpdateCustomerPaymentPreferencePayload } from "../../../Services/api/customer-payment-preferences/customer-payment-preferences.interface";
import { CreateCustomerPaymentPreferencesUseCase } from "../../../Usecase/CustomerPaymentPreferences/create-customer-payment-preferences-usecase";
import { UpdateCustomerPaymentPreferencesUseCase } from "../../../Usecase/CustomerPaymentPreferences/update-customer-payment-preferences-usecase";
import { DestroyCustomerPaymentPreferencesUseCase } from "../../../Usecase/CustomerPaymentPreferences/destroy-customer-payment-preferences-usecase";

interface IUseCreateCustomersProps {
    createCustomersUseCase: CreateCustomersUseCase
     showCustomersUseCase: ShowCustomersUseCase
     updateCustomersUseCase: UpdateCustomersUseCase
     createAddressesUseCase: CreateAddressesUseCase
     updateAddressesUseCase: UpdateAddressesUseCase
     destroyAddressesUseCase: DestroyAddressesUseCase
     createCustomerPaymentPreferencesUseCase: CreateCustomerPaymentPreferencesUseCase
     updateCustomerPaymentPreferencesUseCase: UpdateCustomerPaymentPreferencesUseCase
     destroyCustomerPaymentPreferencesUseCase: DestroyCustomerPaymentPreferencesUseCase
    }

const CreateCustomerSchemaValidation = Yup.object().shape({
    name: Yup.string().required('Nome é obrigatório'),
    email: Yup.string().required('E-mail é obrigatório').email('E-mail inválido'),
    // companyName: Yup.string(),
    document: Yup.string(),
    // stateRegistration: Yup.string(),
    type: Yup.string(),
  });

  interface ICustomerProps extends ICustomerEntity {
    type: CustomerType;
    paymentPreferences?: ICustomerPaymentPreferenceEntity[];
    [key: string]: string | undefined | IAddressEntity[] | boolean | false | ICustomerPaymentPreferenceEntity[] | undefined
  }

  const CustomerTypeOptions = [
    { label: 'Pessoa Física', value: 'PF' },
    { label: 'Pessoa Jurídica', value: 'PJ' },
  ];


  const typePayment = [
    
    {
      value: 'TICKET',
      label: 'Boleto'
    },
   
  ]

export function useCreateCustomers({ createCustomersUseCase, showCustomersUseCase, updateCustomersUseCase, createAddressesUseCase, updateAddressesUseCase, destroyAddressesUseCase, createCustomerPaymentPreferencesUseCase, updateCustomerPaymentPreferencesUseCase, destroyCustomerPaymentPreferencesUseCase }: IUseCreateCustomersProps){
    const [loading, setLoading] = useState(false)
    const [showNewAddressModal, setShowNewAddressModal] = useState(false)
    const [addressSelected, setAddressSelected] = useState<IAddressEntity>()
    const [addresses, setAddresses] = useState<IAddressEntity[]>([])
    const [addressToDestroy, setAddressToDestroy] = useState('')
    const [payments, setPayments] = useState<{
      id: string
			type: any
			installmentsInDays: number
		}[]>([])
    const controlRefresh = useRef(false)
    const [data, setData] = useState<ICustomerEntity>()
    
    const params = useParams()
    
    
    const navigate = useNavigate()
    const { handleSubmit, register, control, formState, watch, setValue, unregister } = useForm<ICustomerProps>({
        resolver: yupResolver(CreateCustomerSchemaValidation),
      });

      

    const customerType = watch('type')

    const { errors } =  formState

    const { showToast } =  useToast()

    const listCustomers = async (customerId: string) => {
      if(controlRefresh.current){
        return
      }   

      controlRefresh.current = true
       
        try {
          setLoading(true)
          
          const showResult = await showCustomersUseCase.handle(customerId);

          if (showResult.isFailure) {
            showToast(String(showResult?.error?.error), 'error');
            return;
          }

         const customer = showResult.getValue()

         if(customer){
          setData(customer)
          setAddresses(customer.addresses || [])

          setValue('name', customer.name)
          setValue('email', customer.email)
          setValue('companyName', customer.companyName)
          setValue('document', customer.document)
          setValue('stateRegistration', customer.stateRegistration)
          setValue('type', customer.personType)
          setValue('phone', customer?.phone ? customer?.phone?.slice(2, customer?.phone?.length) : '')

          if(customer.paymentPreferences?.length){
            const installmentsLength = customer.paymentPreferences[0]?.installmentsInDays?.length || 0

            const normalizePayments = Array.from({ length: installmentsLength }, (_, index) => ({
              id: uuid(),
              type: "TICKET",
              installmentsInDays: customer?.paymentPreferences?.[0]?.installmentsInDays?.[index] || 0
            }))

            console.log("normalizePayments: ", normalizePayments)
            
            setPayments(normalizePayments)

            normalizePayments.forEach((payment) => {
              setValue(`payment-days-${payment.id}`, String(payment.installmentsInDays))
            })
          }

         
         }

        

        } catch (error) {
          console.log("error listCustomers function: ", error)
        } finally {
          setLoading(false);
        }
      };


    const handleAction: SubmitHandler<ICustomerProps> = async (values) => {
      
        // if(!customerType){
        //   showToast('Selecione o tipo de cliente', 'error');
        //   return
        // }

        if(!removeNonNumeric(values.document)){
          showToast('Preencha o documento', 'error');
          return
        }

        const paymentDays = FindKeyWithPrefix(values, 'payment-days-')

        const verifyAllPaymentDays = paymentDays.every((day: { key: string; value: string }) => Number(day.value) > 0)

        if(!verifyAllPaymentDays){
          showToast('Preencha o vencimento em dias', 'error');
          return
        }

        try {
          setLoading(true)

         

          const payloadCreate: ICreateCustomerPayload  = {
            name: values.name,
            email: values.email,
            document: values.document,
            phone: values?.phone ? removeNonNumeric(values.phone) : '',
            stateRegistration: values.stateRegistration,
            personType: 'PJ',
            addresses,
            companyName: values.companyName,
            paymentPreferences: [
              {
                type: 'TICKET',
                installmentsInDays: paymentDays.map((day: { key: string; value: string }) => Number(day.value))
              }
            ]

          }


          const payloadUpdate: IUpdateCustomerPayload  = {
            id: String(params.id),
            name: values.name,
            email: values.email,
            document: values.document,
            phone: values?.phone ? removeNonNumeric(values.phone) : '',
            stateRegistration: values.stateRegistration,
            personType: 'PJ',
            addresses,
            companyName: values.companyName,
          }

          if(params.id){

            if(data?.paymentPreferences?.length){
              // editar preferencia que ja existe
              const payloadUpdatePaymentPreferences: IUpdateCustomerPaymentPreferencePayload = {
                customerId: String(params.id),
                id: String(data.paymentPreferences[0].id),
                preference: {
                  type: 'TICKET',
                  installmentsInDays: paymentDays.map((day: { key: string; value: string }) => Number(day.value))
                }
              }
  
              const updatePaymentPreferencesResult = await updateCustomerPaymentPreferencesUseCase.handle(payloadUpdatePaymentPreferences)
  
              if(updatePaymentPreferencesResult.isFailure){
                showToast(String(updatePaymentPreferencesResult?.error?.error), 'error');
                return; 
              }
            } else {
                // criar preferencia para cliente já existente
              const payloadCreatePaymentPreferences: ICreateCustomerPaymentPreferencePayload = {
                customerId: String(params.id),
                preference: {
                  type: 'TICKET',
                  installmentsInDays: paymentDays.map((day: { key: string; value: string }) => Number(day.value))
                }
              }

              const createPaymentPreferencesResult = await createCustomerPaymentPreferencesUseCase.handle(payloadCreatePaymentPreferences)

              if(createPaymentPreferencesResult.isFailure){
                showToast(String(createPaymentPreferencesResult?.error?.error), 'error');
                return; 
              }
            }

            if(!paymentDays?.length){
              // remover todas as preferencias

              await Promise.all((data?.paymentPreferences || []).map(async (payment) => {
                const payloadDestroyPaymentPreferences: IDestroyCustomerPaymentPreferencePayload = {
                  customerId: String(params.id),
                  id: String(payment?.id)
                }
  
                const destroyPaymentPreferencesResult = await destroyCustomerPaymentPreferencesUseCase.handle(payloadDestroyPaymentPreferences)
  
                if(destroyPaymentPreferencesResult.isFailure){
                  showToast(String(destroyPaymentPreferencesResult?.error?.error), 'error');
                  return; 
                }
              }))
             

            }

          }

          

        
          const storeResult = params.id ? await updateCustomersUseCase.handle(payloadUpdate) :  await createCustomersUseCase.handle(payloadCreate);

          if (storeResult.isFailure) {
            
            showToast(String(storeResult?.error?.error), 'error');
            return;
          }

          showToast(params.id ? 'Cliente Atualizado' : 'Cliente Cadastrado', 'success')
          navigate('/customers-list');

        } catch (error) {
            console.log("error: ", error)
            showToast(error.response?.data?.error ?? 'Erro. Por favor, tente novamente', 'error');
          // toast({
          //   position: 'top-right',
          //   render: () => <ToastCustom type='fail' title='Erro' description={error.response?.data?.error ?? 'Erro ao logar. Por favor, tente novamente'} />,
          // });
        } finally {
          setLoading(false);
        }
      };

  
    useEffect(() => {
      if(params.id){
        listCustomers(params.id)
      }
    },[params?.id])

    const fromEdit = useMemo(() => {
      return !!params.id
    }, [params.id])

    const handleNewLocalAddress = (values: IAddressEntity) => {
  
      setAddresses(prev => [...prev, {id: uuid(), ...values}])
    }

    const handleDestroyLocalAddress = async () => {
      setAddresses(prev => prev.filter(address => address.id !== addressToDestroy))
      setAddressToDestroy('')
    }

    const handleUpdateLocalAddress = (values: IAddressEntity) => {
   
      const currentAddress = addresses.find(address => address.id === values.id)
      if(currentAddress){
        const newAddresses = addresses.map(address => address.id === values.id ? values : address)
        setAddresses([...newAddresses])
      }
    }

    const list = useMemo(() => {
          const rows = addresses?.map(address => {
  
              return {
                  ...address
              }
          })
  
          return rows
    }, [addresses])

    const handleCreateNewAddress = async (address: ICreateAddressPayload) => {
        
      try {
        setLoading(true)
        
        const showResult = await createAddressesUseCase.handle(address);

        if (showResult.isFailure) {
          showToast(String(showResult?.error?.error), 'error');
          return;
        }

        showToast('Novo endereço criado com sucesso', 'success');
    
        listCustomers(String(params.id))



      } catch (error) {
        console.log("error listCustomers function: ", error)
      } finally {
        setLoading(false);
      }
    };

    const handleUpdateAddress = async (address: IAddressEntity) => {
        
      try {
        setLoading(true)
        
        const showResult = await updateAddressesUseCase.handle(address);

        if (showResult.isFailure) {
          showToast(String(showResult?.error?.error), 'error');
          return;
        }

        showToast('Endereço alterado com sucesso', 'success');
    
        listCustomers(String(params.id))



      } catch (error) {
        console.log("error listCustomers function: ", error)
      } finally {
        setLoading(false);
      }
    };

    const handleDestroyAddress = async () => {
        
      try {
        setLoading(true)
        
        const showResult = await destroyAddressesUseCase.handle(String(addressToDestroy));

        if (showResult.isFailure) {
          showToast(String(showResult?.error?.error), 'error');
          return;
        }

        showToast('Endereço excluído com sucesso', 'success');
        setAddressToDestroy('')
        listCustomers(String(params.id))

      

      } catch (error) {
        console.log("error handleDestroyAddress function: ", error)
      } finally {
        setLoading(false);
      }
    };

    const handleAddNewPayment = () => {
      setPayments(prev => [...prev, {
        id: uuid(),
        type: 'TICKET',
        installmentsInDays: 0

      }])
    }

    const handleRemovePayment = (id: string) => {
      setPayments(prev => prev.filter(payment => payment.id !== id))
      unregister(`payment-days-${id}`)
    }

      

    return {
        loading,
        handleSubmit,
        handleAction,
        register,
        customerType,
        errors,
        data,
        CustomerTypeOptions,
        control,
        setShowNewAddressModal,
        showNewAddressModal,
        setAddressSelected,
        addressSelected,
        handleNewLocalAddress,
        addresses,
        list,
        setAddressToDestroy,
        addressToDestroy,
        handleDestroyAddress,
        handleUpdateAddress,
        fromEdit,
        handleCreateNewAddress,
        customerId: params.id,
        handleUpdateLocalAddress,
        handleDestroyLocalAddress,
        typePayment,
        handleAddNewPayment,
        payments,
        setPayments,
        watch,
        handleRemovePayment
        
        
    }
}